import React, { useEffect } from 'react';
import useStore from '../store';
import '../styles/cinematic.css';

const LoaderUI = () => {
    const isLoaded = useStore(state => state.isLoaded);
    const setIsLoaded = useStore(state => state.setIsLoaded);

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsLoaded(true);
        }, 3000);

        return () => clearTimeout(timer);
    }, [setIsLoaded]);

    if (isLoaded) return null;

    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(11, 14, 46, 0.7)', // Slightly more opaque
            backdropFilter: 'blur(4px)', // Reduced for iOS Safari perf
            WebkitBackdropFilter: 'blur(4px)',
            transform: 'translateZ(0)', // Force Hardware Acceleration
            zIndex: 9999,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            transition: 'opacity 1.5s ease-in-out',
            opacity: isLoaded ? 0 : 1,
            pointerEvents: isLoaded ? 'none' : 'auto',
            willChange: 'opacity'
        }}>
            <div className="ferris-wheel-container" style={{ position: 'relative', width: '120px', height: '120px', marginBottom: '40px', transform: 'translateZ(0)' }}>

                {/* Wheel Structure */}
                <div className="wheel" style={{
                    width: '100%',
                    height: '100%',
                    border: '4px solid rgba(0, 245, 255, 0.3)',
                    borderRadius: '50%',
                    position: 'relative',
                    animation: 'spin 3s linear infinite',
                    boxShadow: '0 0 20px rgba(0, 245, 255, 0.2)'
                }}>
                    {/* Center Hub */}
                    <div style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        width: '12px',
                        height: '12px',
                        background: '#fff',
                        borderRadius: '50%',
                        transform: 'translate(-50%, -50%)',
                        zIndex: 2,
                        boxShadow: '0 0 10px #fff'
                    }} />

                    {/* Spokes */}
                    {[0, 45, 90, 135].map(deg => (
                        <div key={deg} style={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            width: '100%',
                            height: '2px',
                            background: 'rgba(0, 245, 255, 0.4)',
                            transform: `translate(-50%, -50%) rotate(${deg}deg)`
                        }} />
                    ))}

                    {/* Pink Lights on the Rim */}
                    {Array.from({ length: 16 }).map((_, i) => (
                        <div key={`light-${i}`} style={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            width: '4px',
                            height: '4px',
                            background: '#FF0095',
                            borderRadius: '50%',
                            transform: `translate(-50%, -50%) rotate(${i * 22.5}deg) translate(58px) rotate(-${i * 22.5}deg)`,
                            boxShadow: '0 0 5px #FF0095',
                            zIndex: 3
                        }} />
                    ))}

                </div>

                {/* Base / Stand */}
                <div className="stand" style={{
                    position: 'absolute',
                    bottom: '-20px',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    width: '60px',
                    height: '70px',
                    zIndex: 0
                }}>

                </div>
            </div>


            <h2 className="neon-text-pink flicker-fast" style={{
                fontSize: 'clamp(1.5rem, 6vw, 2.5rem)', // Large size for new hero text
                letterSpacing: '5px',
                textIndent: '5px', // Balances trailing letter-spacing
                textAlign: 'center',
                textTransform: 'uppercase',
                margin: '0 0 20px 0',
                width: '100%',
                padding: '0 10px',
                animation: 'blink-glow-fast 1s infinite alternate-reverse',
                color: '#FF0095'
            }}>
                PERFORMERS REVEALED
            </h2>
            <h2 className="neon-text-pink" style={{
                fontSize: 'clamp(1.2rem, 5vw, 2rem)', // Responsive font size
                letterSpacing: '4px',
                textIndent: '4px', // Balances trailing letter-spacing
                textAlign: 'center',
                textTransform: 'uppercase',
                margin: '0',
                width: '100%',
                padding: '0 10px',
                animation: 'blink-glow 2s infinite alternate'
            }}>
                Setting up CARNIVAL
            </h2>
            <h6 className="neon-text-pink" style={{
                fontSize: 'clamp(0.5rem, 2vw, 0.7rem)', // Slightly larger for readability
                letterSpacing: '3px',
                textIndent: '3px', // Balances trailing letter-spacing
                textTransform: 'uppercase',
                margin: '10px 0 0 0',
                textAlign: 'center',
                width: '100%',
                padding: '0 10px',
                opacity: 0.8,
                animation: 'blink-glow 3s infinite alternate-reverse' // Offset animation
            }}>
                best experience on desktop
            </h6>

            <style>{`
                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
                @keyframes blink-glow {
                    0% { opacity: 0.3; }
                    50% { opacity: 1; }
                    100% { opacity: 0.3; }
                }
                @keyframes blink-glow-fast {
                    0% { opacity: 0.4; }
                    50% { opacity: 1; }
                    100% { opacity: 0.4; }
                }
            `}</style>
        </div>
    );
};

export default LoaderUI;
